import { UserAgreementForm } from "interface/userAgreement";

export type CustomerTypeKey =
	| "customerFisher"
	| "customerBuyer"
	| "customerStorage"
	| "customerSales";

// export const handleTypeToggle = (
// 	typeKey: CustomerTypeKey
// ): Partial<UserAgreementForm> => {
// 	switch (typeKey) {
// 		case "customerFisher":
// 			return { vesselName: "", vesselRegNo: "" };
// 		case "customerBuyer":
// 			return { buyerName: "", buyerRegNo: undefined };
// 		case "customerStorage":
// 			return { terminalName: "", terminalCode: undefined };
// 		case "customerSales":
// 			return {
// 				buyerName: "",
// 				buyerRegNo: undefined,
// 				vesselName: "",
// 				vesselRegNo: "",
// 			};
// 		default:
// 			return {};
// 	}
// };

export const computeClearedFields = (
	typeKey: CustomerTypeKey,
	current: UserAgreementForm
): Partial<UserAgreementForm> => {
	const clears: Partial<UserAgreementForm> = {};
	if (typeKey === "customerFisher") {
		if (!current.customerSales) {
			clears.vesselName = "";
			clears.vesselRegNo = "";
		}
	} else if (typeKey === "customerBuyer") {
		// Buyer also shown for Sales
		if (!current.customerSales) {
			clears.buyerName = "";
			clears.buyerRegNo = undefined;
		}
	} else if (typeKey === "customerStorage") {
		clears.terminalName = "";
		clears.terminalCode = undefined;
	} else if (typeKey === "customerSales") {
		if (!current.customerFisher) {
			clears.vesselName = "";
			clears.vesselRegNo = "";
		}
		if (!current.customerBuyer) {
			clears.buyerName = "";
			clears.buyerRegNo = undefined;
		}
	}
	return clears;
};

export const defaultForm: UserAgreementForm = {
	userFirstName: "",
	userLastName: "",
	userPhone: "",
	userEmail: "",
	userPhonePrefix: "+47",
	userDevices: "",
	// userReadAccess: null,
	// auctionAccess: null,
	// noteWriteAccess: null,
	// approveSalesAccess: null,
	// userAgreementId: null,
	vesselName: "",
	vesselRegNo: "",
	customerName: "",
	orgNoPersNo: undefined,

	customerType: undefined,
	accessType: undefined, // 1 for replace, 2 for new
	readAccess: true,
	confirmed: false,
	customerFisher: false,
	customerBuyer: false,
	customerStorage: false,
	customerSales: false,
	termsOfUse: false,

	buyerName: undefined,
	buyerRegNo: undefined,
	terminalName: undefined,
	terminalCode: undefined,
};
